import Main from './pages/Main/Main';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import './App.css';
import TransferStatus from './pages/Merchant/TransferStatus/TransferStatus';
import { Transfer } from './pages/Merchant/Transfer/Transfer';
import { CreateOrder } from './pages/Merchant/CreateOrder/CreateOrder';
import { Currency } from './pages/Merchant/Currency/Currency';
import MerchantAuth from './pages/Merchant/MerchantAuth/MerchantAuth';
import {
  CREATE_ORDER,
  DISPUTE_PAYMENT,
  FORBIDDEN_ERROR,
  MERCHANT_AUTH,
  NOT_FOUND_ERROR,
  SERVER_ERROR,
  TRANSFER,
  TRANSFER_STATUS,
  CURRENCY,
  WITHDRAWAL,
} from './utils/routes';
import { ProtectedRouterMerchant } from './services/ProtectedRouterMerchant';
import { NotFoundError } from './pages/Errors/NotFoundError';
import React from 'react';
import { ForbiddenError } from './pages/Errors/ForbiddenError';
import { ServerError } from './pages/Errors/ServerError';
import DisputePayment from './pages/Disputes';
import Withdrawal from './pages/Withdrawal';

function App() {
  return (
    <Router>
      <Routes>
        {/* Dispute */}
        <Route
          path={DISPUTE_PAYMENT}
          element={<DisputePayment />}
        />

        {/* Логин */}
        <Route
          path={MERCHANT_AUTH}
          element={<MerchantAuth />}
        />

        {/* При заходе на “/” сразу на MERCHANT_AUTH */}
        <Route
          index
          element={<Navigate to={MERCHANT_AUTH} replace />}
        />

        {/* Защищённые роуты — сюда попадают только после <ProtectedRouterMerchant> */}
        <Route element={<ProtectedRouterMerchant />}>
          <Route
            path={CREATE_ORDER}
            element={<CreateOrder />}
          />
          <Route
            path={CURRENCY}
            element={<Currency />}
          />
          <Route
            path={WITHDRAWAL}
            element={<Withdrawal />}
          />
          <Route
            path={`${TRANSFER}/:id`}
            element={<Transfer />}
          />
          <Route
            path={`${TRANSFER_STATUS}/:id`}
            element={<TransferStatus />}
          />
        </Route>

        {/* Если путь не найден — редирект на логин */}
        <Route
          path="*"
          element={<Navigate to={MERCHANT_AUTH} replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
